import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
const fetchWikipedia = async (query) => {
    const res = await fetch(`https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(query)}`);
    if (!res.ok)
        throw new Error("Failed to fetch from Wikipedia");
    return res.json();
};
export const InstantAnswerWidget = ({ query }) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ["wikipedia", query],
        queryFn: () => fetchWikipedia(query),
        enabled: !!query,
    });
    if (isLoading)
        return null;
    if (error)
        return null;
    if (!data)
        return null;
    return (_jsxs("div", { className: "p-4 rounded-3xl shadow-lg h-auto bg-white overflow-auto w-1/2 flex flex-col items-center", children: [data.thumbnail?.source && (_jsx("img", { src: data.thumbnail.source, alt: data.title, className: "w-64 h-auto rounded mt-4" })), data.title && (_jsx("h2", { className: "text-3xl mb-4 font-semibold my-4", children: data.title })), data.extract ? (_jsxs("p", { className: "text-gray-700", children: [data.extract, " ", data.content_urls?.desktop?.page && (_jsx("a", { href: data.content_urls.desktop.page, target: "_blank", rel: "noopener noreferrer", className: "text-blue-600 underline", children: "Learn more" }))] })) : (_jsx("p", { className: "text-gray-500 italic", children: "No summary available" }))] }));
};
export default InstantAnswerWidget;
